module.exports = __webpack_public_path__ + "static/media/Icons-Navigation-Logo.f0d8dc84.svg";